import Logo from 'assett/icons/logo.svg';
import SelectLanguage from 'components/commons/form/SelectLanguage';
import { setDialogOpen, setInjectionState } from 'feature/hooks/dialogSlice';
import useDevice from 'hooks/DesktopDevice.hook';
import useDialogConfirm from 'hooks/DialogConfirm.hook';
import { useResetPage } from 'hooks/utils.hook';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { RootState } from 'store/store';
import { Box } from 'styles';
import CardMedia from 'styles/card/CardMedia';
import Container from 'styles/container/Container';
import Stack from 'styles/stack/Stack';
import Typography from 'styles/typography/Typograpy';
import { VERSION } from 'types/dialogTypes';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';
import { FooterDesktop } from './FooterDesktop/FooterDesktop';

const DashboardLayout = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { profile } = useSelector((store: RootState) => store.user);

	const dispatch = useDispatch();

	const { isDesktop } = useDevice();
	const confirmDialog = useDialogConfirm();

	useResetPage();

	return (
		<Container>
			<Stack
				justifyContent="space-between"
				height={!isDesktop ? `${window.innerHeight}px` : '100vh'}
			>
				<Box sx={{}}>
					<Stack
						sx={{ mt: 6.25 }}
						direction={'row'}
						justifyContent={'space-between'}
					>
						<Stack>
							<Typography variant="title1" role="heading" aria-level={1}>
								{tClientLabels('dashboard.pageTitle')}
							</Typography>
							<Typography
								variant={!!isDesktop ? 'title2' : 'title4'}
								sx={{ color: 'primary3.main' }}
							>
								{profile?.name as string}
							</Typography>
						</Stack>
						<Stack alignItems={'flex-end'}>
							<Box width="48px" height="60px" sx={{ cursor: 'pointer' }}>
								<CardMedia
									component="img"
									image={Logo}
									onClick={() => {
										dispatch(setInjectionState(confirmDialog.open(VERSION)));
										dispatch(setDialogOpen(true));
									}}
								/>
							</Box>
						</Stack>
					</Stack>
					<Stack direction={'row'} justifyContent="space-between">
						<Box width={{ sm: '68%', lg: '60%' }}></Box>
						<Box>
							<SelectLanguage />
						</Box>
					</Stack>
				</Box>
				<Stack mb={isDesktop ? 6.5 : 2.5}>
					<Outlet />
				</Stack>
				<FooterDesktop />
			</Stack>
		</Container>
	);
};

export default DashboardLayout;
